export enum LivesWith {
  Alone = 'ALONE',
  Children = 'CHILDREN',
  Father = 'FATHER',
  FosterCare = 'FOSTER_CARE',
  Grandparent = 'GRANDPARENT',
  Mother = 'MOTHER',
  Siblings = 'SIBLINGS',
  SignificantOther = 'SIGNIFICANT_OTHER',
  Spouse = 'SPOUSE',
  Stepfather = 'STEPFATHER',
  Stepmother = 'STEPMOTHER',
  Other = 'OTHER',
}

export const livesWithMap: {
  [value in LivesWith]: string;
} = {
  [LivesWith.Alone]: 'Alone',
  [LivesWith.Children]: 'Children',
  [LivesWith.Father]: 'Father',
  [LivesWith.FosterCare]: 'Foster Care',
  [LivesWith.Grandparent]: 'Grandparent',
  [LivesWith.Mother]: 'Mother',
  [LivesWith.Siblings]: 'Siblings',
  [LivesWith.SignificantOther]: 'Significant Other',
  [LivesWith.Spouse]: 'Spouse',
  [LivesWith.Stepfather]: 'Stepfather',
  [LivesWith.Stepmother]: 'Stepmother',
  [LivesWith.Other]: 'Other',
};

export enum Risk {
  AnimalExposure = 'ANIMAL_EXPOSURE',
  Daycare = 'DAYCARE',
  HazardousChemicals = 'HAZARDOUS_CHEMICALS',
  HighRiskSports = 'HIGH_RISK_SPORTS',
  MoldWaterDamageInHome = 'MOLD_WATER_DAMAGE_IN_HOME',
  NoHelmet = 'NO_HELMET',
  NoSeatbelts = 'NO_SEATBELTS',
  NoSmokeDetectors = 'NO_SMOKE_DETECTORS',
  PoolLake = 'POOL_LAKE',
  Stairs = 'STAIRS',
  UnlockedGuns = 'UNLOCKED_GUNS',
  Other = 'OTHER',
}

export const risksMap: {
  [value in Risk]: string;
} = {
  [Risk.AnimalExposure]: 'Exposed to pets/animals',
  [Risk.Daycare]: 'Daycare',
  [Risk.HazardousChemicals]: 'Exposed to hazardous chemicals or paint',
  [Risk.HighRiskSports]: 'Participate in high risk sports',
  [Risk.MoldWaterDamageInHome]: 'Home has mold/water damage',
  [Risk.NoHelmet]: 'Does not wear helmet',
  [Risk.NoSeatbelts]: 'Does not use seatbelts',
  [Risk.NoSmokeDetectors]: 'Home does not have smoke/CO detectors',
  [Risk.PoolLake]: 'Home has a pool/is on a lake',
  [Risk.Stairs]: 'Home has stairs',
  [Risk.UnlockedGuns]: 'Unlocked guns',
  [Risk.Other]: 'Other',
};

export enum LivingSituation {
  AssistedLivingFacility = 'ASSISTED_LIVING_FACILITY',
  HomeIndependent = 'HOME_INDEPENDENT',
  HomeWithAssistance = 'HOME_WITH_ASSISTANCE',
  HomelessShelter = 'HOMELESS_SHELTER',
  Hospice = 'HOSPICE',
  SkilledNursingFacility = 'SKILLED_NURSING_FACILITY',
  Other = 'OTHER',
}

export const livingSituationMap: {
  [value in LivingSituation]: string;
} = {
  [LivingSituation.AssistedLivingFacility]: 'Assisted Living Facility',
  [LivingSituation.HomeIndependent]: 'Home/Independent',
  [LivingSituation.HomeWithAssistance]: 'Home with Assistance',
  [LivingSituation.HomelessShelter]: 'Homeless Shelter',
  [LivingSituation.Hospice]: 'Hospice',
  [LivingSituation.SkilledNursingFacility]: 'Skilled Nursing Facility',
  [LivingSituation.Other]: 'Other',
};

export enum ParentsMaritalStatus {
  Cohabitating = 'COHABITATING',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Separated = 'SEPARATED',
  Unmarried = 'UNMARRIED',
  Widowed = 'WIDOWED',
  Other = 'OTHER',
}

export const parentsMaritalStatusMap: {
  [value in ParentsMaritalStatus]: string;
} = {
  [ParentsMaritalStatus.Cohabitating]: 'Cohabitating',
  [ParentsMaritalStatus.Divorced]: 'Divorced',
  [ParentsMaritalStatus.Married]: 'Married',
  [ParentsMaritalStatus.Separated]: 'Separated',
  [ParentsMaritalStatus.Unmarried]: 'Unmarried',
  [ParentsMaritalStatus.Widowed]: 'Widowed',
  [ParentsMaritalStatus.Other]: 'Other',
};

export interface PatientEnvironment {
  livesWith: LivesWith[] | null;
  livesWithRaw: string[] | null;
  livingSituation: LivingSituation | null;
  livingSituationRaw: string | null;
  familyFriendsAvailableToHelp: boolean | null;
  risks: Risk[] | null;
  risksRaw: string[] | null;
  parentsGuardianInfo: string | null;
  siblingInfo: string | null;
  parentsMaritalStatus: ParentsMaritalStatus | null;
  parentsMaritalStatusRaw: string | null;
}
